import * as React from 'react';

const Globe = ({fillColor = '#2961fa'}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 17"
    fill="none">
    <path
      stroke={fillColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 15.167A6.667 6.667 0 1 0 8 1.834a6.667 6.667 0 0 0 0 13.333Z"
    />
    <path
      stroke={fillColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.333 2.5H6a18.949 18.949 0 0 0 0 12h-.667M10 2.5c1.3 3.893 1.3 8.107 0 12"
    />
    <path
      stroke={fillColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2 11.167V10.5c3.893 1.3 8.107 1.3 12 0v.667M2 6.5c3.893-1.3 8.107-1.3 12 0"
    />
  </svg>
);

export default Globe;
